import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InsuranceService } from '../insurance.service';
import { PatientEditComponent } from '../../patient/patient-edit/patient-edit.component';
import { PatientService } from '../../patient/patient.service';
import {CommMethodEnum} from '../../../models/enum/comm-method.enum';
import {PatientDialogDataModel} from '../../patient/patient-dialog-data.model';
import {PatientInsuranceDataModel} from '../../../models/patient/patient-insurance-data.model';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {PatientContactDataModel} from '../../../models/patient/patient-contact-data.model';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
//import {InsuranceRelationEnum} from '../../../models/enum/insurance-relation.enum';
import { StaticDataService } from '../../../services/static-data.service';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {SelectionModel} from '@angular/cdk/collections';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {MatTableDataSource} from '@angular/material/table';
import {ContactCommsDataModel} from '../../../models/person/contact-comms-data.model';
import {PatientSubscriberContactListModel} from '../models/patient-subscriber-contact-list.model';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {Globals} from '../../../globals';
import { FormatPhonePipe } from 'src/app/pipes/format-phone.pipe';
import {ValidValuesService} from '../../configuration/valid-values/valid-values.service';
import {Constants} from '../../../constants';

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  actions = [];
  FirstName: string;
  LastName: string;
  PhoneHome: string;
  PhoneMobile: string;
  ContactId: string;
  PatientRelationshipName: string;
  model: PatientSubscriberContactListModel;


  getActionTooltip(actionName: string): string {
    let tooltip = '';
    switch (actionName) {
      case TdoTableActionsEnum.DELETE:
        tooltip = `Delete ${this.FirstName + ' ' + this.LastName}`;
        break;
    }
    return tooltip;
  }
}

@Component({
  selector: 'app-insurance-manage-subscribers',
  templateUrl: './insurance-manage-subscribers.component.html',
  styleUrls: ['./insurance-manage-subscribers.component.css']
})

export class InsuranceManageSubscribersComponent implements OnInit {

  // page state variables
  currentPatientId: string;
  pageInitialized: boolean = false;
  isLoading: boolean = true;
  existingContactMode: boolean = true;
  selectedContact: boolean = false;
  patientPayment: boolean = false;

  // db data variables
  dataPatientInsurance: PatientInsuranceDataModel;
  dataPatientInsuranceBackup: PatientInsuranceDataModel;
  //relationshipEnums: EnumValidValueItemModel[] = [];
  patientContactTypeEnums: EnumValidValueItemModel[] = [];
  patientContacts: PatientContactDataModel[] = [];
  patientSubscriberContacts: PatientSubscriberContactListModel[] = [];
  currentPatient: PatientDataModel;
  patientIsSubscriber: boolean;
  enumInsuranceRelation: any[] ;

  // Table
  tableModel: TdoTableModel;
  displayedColumns: string[] = ['FirstName', 'LastName', 'PatientRelationshipName', 'PhoneHome', 'PhoneMobile', 'actions'];
  displayedColumnsLabels: string[] = ['First Name', 'Last Name', 'Relationship', 'Home Phone', 'Mobile Phone' ];
  dataSource: MatTableDataSource<TableViewData>;
  selection = new SelectionModel<TableViewData>(false, []);
  tableViewData: TableViewData[];
  selectedItem: TdoTableBaseItemModel;

  // variables for payment selecting a contact
  paymentContactId: string;
  paymentContactLastName: string;
  paymentContactFirstName: string;

  InsuranceRelationEnum : any = {
    Self        : '00000045-1000-0000-0000-000000000001',
    Spouse      : '00000045-1000-0000-0000-000000000002',
    Child       : '00000045-1000-0000-0000-000000000003',
    Employee       : '00000045-1000-0000-0000-000000000004',
    HandicappedDependent       : '00000045-1000-0000-0000-000000000005',
    SignificantOther       : '00000045-1000-0000-0000-000000000006',
    InjuredPlaintiff       : '00000045-1000-0000-0000-000000000007',
    LifePartner       : '00000045-1000-0000-0000-000000000008',
    Dependent       : '00000045-1000-0000-0000-000000000009',
  }



  constructor(
    private insuranceService: InsuranceService,
    private patientService: PatientService,
    private formatPhonePipe: FormatPhonePipe,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globals: Globals,
    private staticDataService: StaticDataService,
    public dialogRef: MatDialogRef<InsuranceManageSubscribersComponent>,
    private validvalueService: ValidValuesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {


    this.staticDataService.getValidValueItemsByName('enumInsuranceRelation').subscribe(res=> {
      console.log('enumInsuranceRelation', res);

      this.enumInsuranceRelation =res;

    });




    // get patient contact type enums
    this.validvalueService.callGetenumValidValueItems('enumPatientContactType').subscribe((enumTypes) => {
      this.patientContactTypeEnums = enumTypes;
    }, err => {
      this.createMessage('Error loading patient contact type enums', 'Error');
    });

    this.currentPatient = this.data.currentPatient;
    this.currentPatientId = this.data.currentPatientId;
    this.dataPatientInsurance = this.data.dataPatientInsurance;
    this.dataPatientInsuranceBackup = this.data.dataPatientInsurance;
    this.patientPayment = this.data.contactSelect ? this.data.contactSelect : false;

    // get contacts for current patient
    this.getPatientContacts().then((results: PatientContactDataModel[]) => {
      this.patientContacts = results;
      this.pageInitialized = true;

      // convert results to patientSubscriberContacts model to be displayed in table
      for (let contact of this.patientContacts)
      {
        const subscriberContact = new PatientSubscriberContactListModel();
        subscriberContact.FirstName = contact.dataContact.FirstName;
        subscriberContact.LastName = contact.dataContact.LastName;
        subscriberContact.PhoneHome = this.returnCommString(contact.dataContact.dataContactComms, CommMethodEnum.Phone);
        subscriberContact.PhoneMobile = this.returnCommString(contact.dataContact.dataContactComms, CommMethodEnum.Mobile);
        subscriberContact.dataContact = contact.dataContact;
        subscriberContact.PatientRelationshipName = this.returnPatientRelationshipName(contact.enumPatientContactTypeID);
        this.patientSubscriberContacts.push(subscriberContact);
      }

      this.isLoading = false;

      // load contacts table
      this.refreshTableViewData();

      // show already selected subscriber, if exists
      if(!this.patientPayment) {
        this.checkForDataPatientInsuranceSubscriber(this.dataPatientInsurance);
      }
    }, err => {
      // need to display error message
    });


  }

  returnPatientRelationshipName(enumID: string) {
    const cType = this.patientContactTypeEnums.find(a => a.ValidValueItemId === enumID);
    if (cType) {
      return cType.ItemDisplayValue;
    }
    else {
      return '';
    }
  }

  getPatientContacts() {
    const promise = new Promise((resolve, reject) => {
      this.patientService.getPatientContacts(this.currentPatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  checkForDataPatientInsuranceSubscriber(dataPatientInsurance: PatientInsuranceDataModel) {
    if (dataPatientInsurance.enumInsuranceRelationId === this.InsuranceRelationEnum.Self) {
      // patient is the subscriber
      this.patientIsSubscriber = true;
    }
    else {
      this.patientIsSubscriber = false;
    }
  }

  patientIsSubscriberChanged(checked: boolean) {
    this.patientIsSubscriber = checked;

    if (this.patientIsSubscriber) {
      this.setPatientAsSubscriber();
    }
    else {
      this.resetPatientAsSubscriber();
    }
  }

  switchMode(existingContactMode) {
    this.selectedContact = false;
    this.existingContactMode = existingContactMode;
  }

  selectPatientContact(contact) {
    this.dataPatientInsurance.SubsciberContactId = contact.ContactId;
    this.dataPatientInsurance.SubscriberContact = contact;
    this.dataPatientInsurance.enumInsuranceRelationId = contact.enumPatientContactTypeID;
    this.dataPatientInsurance.SubsciberBirthdate = contact.BirthDate;
  }
  setPatientAsSubscriber() {
    const contactObj = this.currentPatient.dataContact;
    this.dataPatientInsurance.SubsciberContactId = contactObj.ContactId;
    this.dataPatientInsurance.SubscriberContact = contactObj;
    this.dataPatientInsurance.enumInsuranceRelationId = this.InsuranceRelationEnum.Self;
    this.dataPatientInsurance.SubsciberBirthdate = contactObj.BirthDate;

    // undo table selection
    const blah = this.tableViewData;
    this.tableViewData.forEach(a => {
      a.isSelected = false;
    });
    this.refreshTableViewData();
  }

  resetPatientAsSubscriber() {
    this.dataPatientInsurance.SubsciberContactId = null;
    this.dataPatientInsurance.SubscriberContact = null;
    this.dataPatientInsurance.enumInsuranceRelationId = null;
    this.dataPatientInsurance.SubsciberBirthdate = null;
  }

  updateDataPatientInsurance(closeAfterComplete: boolean) {
    this.isLoading = true;

    // if subscriber not self..
    let enumInsuranceRelationId: string = Constants.emptyGuid;
    if (!this.patientIsSubscriber && this.dataPatientInsurance.SubscriberContact) {
      this.patientContacts.forEach(a => {
        if (a.ContactId === this.dataPatientInsurance.SubsciberContactId)
        {
          enumInsuranceRelationId =   this.dataPatientInsurance.enumInsuranceRelationId;  //a.enumPatientContactTypeID;
        }
      });
    }
    else {
      // is self..
      enumInsuranceRelationId = this.dataPatientInsurance.enumInsuranceRelationId;
    }

    this.insuranceService.updateDataPatientInsurance(this.dataPatientInsurance, enumInsuranceRelationId)
      .subscribe(response => {
        this.isLoading = false;
        if (closeAfterComplete)
        {
          this.dialogRef.close();
        }
      }, err => {
        this.isLoading = false;
        this.showMessage('Error', 'Error updating contact');
      });
  }

  closeRef() {
    this.dataPatientInsurance = this.dataPatientInsuranceBackup;
    this.dialogRef.close();
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  openCreatePatientComponent() {
    const dm = new PatientDialogDataModel();
    dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
    dm.title = 'New Contact';
    dm.entityType = PatientDialogDataModel.TYPE_PATIENT;
    dm.entityId = this.globals.currentPatientId;
    if (this.globals.ThePatient) {
      dm.entity = this.globals.ThePatient;
    }
    dm.itemName = 'contacts';
    const dialogRef = this.dialog.open(PatientEditComponent, {
      panelClass: 'dialog',
      width: '968px',
      height: '600px',
      data: dm
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        this.getPatientContacts()
          .then((results: PatientContactDataModel[]) => {
            this.patientContacts = results;

            // convert results to patientSubscriberContacts model to be displayed in table
            this.patientSubscriberContacts = [];
            for (let contact of this.patientContacts)
            {
              const subscriberContact = new PatientSubscriberContactListModel();
              subscriberContact.FirstName = contact.dataContact.FirstName;
              subscriberContact.LastName = contact.dataContact.LastName;
              subscriberContact.PhoneHome = this.returnCommString(contact.dataContact.dataContactComms, CommMethodEnum.Phone);
              subscriberContact.PhoneMobile = this.returnCommString(contact.dataContact.dataContactComms, CommMethodEnum.Mobile);
              subscriberContact.dataContact = contact.dataContact;
              subscriberContact.PatientRelationshipName = this.returnPatientRelationshipName(contact.enumPatientContactTypeID);
              this.patientSubscriberContacts.push(subscriberContact);
            }

            results.forEach(contact => {
              if (contact.ContactId === result.ContactId) {
                this.selectPatientContact(contact);
                return;
              }
            });

            // reload grid
            this.refreshTableViewData();

            this.isLoading = false;
            return;

          }, err => {
            this.isLoading = false;
          });
      }
    }, err => {
      // reject(err);
    });
  }

  onTdoTableItemActionClick(event: TdoTableEvent): void {
    const model = (event.value as TableViewData).model;
    // switch (event.action) {
    //   case TdoTableActionsEnum.DELETE:
    // }
  }

  onTdoTableItemClick(event: TdoTableEvent): void {
    const row = event.value as TableViewData;

    // undo subscriber is patient
    this.patientIsSubscriber = false;

    // save selected subscriber contact
    if(this.patientPayment) {
      this.paymentContactId = row.model.dataContact.ContactId;
      this.paymentContactFirstName = row.model.dataContact.FirstName;
      this.paymentContactLastName = row.model.dataContact.LastName;
    }else{
      this.dataPatientInsurance.SubsciberContactId = row.model.dataContact.ContactId;
      this.dataPatientInsurance.SubscriberContact = row.model.dataContact;
      this.dataPatientInsurance.SubsciberBirthdate = row.model.dataContact.BirthDate;
      this.dataPatientInsurance.enumInsuranceRelationId =  this.getInsuranceRelationship(row.model.PatientRelationshipName);
    }
  }

  getInsuranceRelationship(relationship: string) {


      let r = this.enumInsuranceRelation.find(f=> f.ItemDisplayValue == relationship);
      if(r)
      {
        return r.ValidValueItemId;
        //return Constants.emptyGuid;
      }

      switch (relationship) {
        case 'Daughter':
        case 'Son':
          return this.InsuranceRelationEnum.Child;
        case 'Spouse':
          return this.InsuranceRelationEnum.Spouse;
        case 'Employee':
          return this.InsuranceRelationEnum.Employee;
        case 'Handicapped Dependent':
          return this.InsuranceRelationEnum.HandicappedDependent;
        case 'Significant Other':
          return this.InsuranceRelationEnum.SignificantOther;
        case 'Injured Plaintiff':
          return this.InsuranceRelationEnum.InjuredPlaintiff;
        case 'Life Partner':
          return this.InsuranceRelationEnum.LifePartner;
        case 'Dependent':
          return this.InsuranceRelationEnum.Dependent;



        default:
          this.createMessage('Warning', 'Please select the proper relationship to patient.');
          return Constants.emptyGuid;
      }









}

  returnCommString(dataContactComms: ContactCommsDataModel[], commMethod: string): string {
    const phoneNumber: ContactCommsDataModel[] = dataContactComms.filter(com => {
      if (!com.enumCommMethodID) { return false; }
      return (com.enumCommMethodID === commMethod);
    });

    if (phoneNumber.length) {
      return phoneNumber[0].Address;
    }
    else {
      return null;
    }
  }

  refreshTableViewData(){
    this.tableViewData = Array.from(this.patientSubscriberContacts, (_) => {
      const model = new TableViewData();
      model.FirstName = _.FirstName;
      model.LastName = _.LastName;
      model.PhoneHome = _.PhoneHome;
      model.PhoneMobile = _.PhoneMobile;
      model.ContactId = _.dataContact.ContactId;
      model.PatientRelationshipName = _.PatientRelationshipName;
      if(!this.patientPayment){
        model.isSelected = model.ContactId === this.dataPatientInsurance.SubsciberContactId;
      }
      model.model = _;
      return model;
    });

    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'FirstName', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (
            (data.FirstName ? data.FirstName : '').toLowerCase().includes(filter) ||
            (data.LastName ? data.LastName : '').toLowerCase().includes(filter) ||
            (data.PhoneHome ? data.PhoneHome : '').toLowerCase().includes(filter) ||
            (data.PhoneMobile ? data.PhoneMobile : '').toLowerCase().includes(filter)
        ) {
          return true;
        }
      };
    }
    else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();
    }
  }

  save() {
    if(this.patientPayment){
      this.showSelectedContact();
    }else{
      this.updateDataPatientInsurance(true);
    }
  }

  showSelectedContact(){
    // close
    const result = [this.paymentContactId, this.paymentContactFirstName, this.paymentContactLastName];
    this.dialogRef.close(result);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 6000,
      verticalPosition: 'top',
      panelClass: ['snackbar-linebreaks']
    });
  }
}
